"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNiftoryClient = void 0;
const react_1 = require("react");
const NiftoryProvider_1 = require("./NiftoryProvider");
/*
 * Hook for getting NiftoryClient belonging to the current context. This is undefined when provider client is not initialized
 */
const useNiftoryClient = () => { var _a; return (_a = (0, react_1.useContext)(NiftoryProvider_1.NiftoryContext)) === null || _a === void 0 ? void 0 : _a.client; };
exports.useNiftoryClient = useNiftoryClient;
